import apiPaths from '../api-paths.js';

export default {
  createBatch() {
    return axios.post(`${ apiPaths.BOOKKEEPING }/import-batches`);
  },
  uploadFile(batchId, formData) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }/upload-file`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  updateBatch(batchId, data) {
    return axios.put(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }`, data);
  },
  importBatch(batchId) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }/import`);
  },
  getBatch(batchId) {
    return axios.get(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }`);
  },
  getBatches(query = '') {
    return axios.get(`${ apiPaths.BOOKKEEPING }/import-batches${ query }`);
  },
  updateInvoice(batchId, invoiceId, data) {
    return axios.patch(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }/invoices/${ invoiceId }`, data);
  },
  deleteInvoice(batchId, invoiceId) {
    return axios.delete(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }/invoices/${ invoiceId }`);
  },
  retryFailed(batchId) {
    return axios.post(`${ apiPaths.BOOKKEEPING }/import-batches/${ batchId }/retry-failed`);
  },
};
